import { enumElementDrawStates, enumImageIndex, kMediumIcon, kOCNTextColor } from "../constants";
import { doDrawIcon } from "../utils/doDrawIcon";
import { SetCtxFont } from "../utils/SetCtxFont";
import { QButton } from "./QButton";

export class QIDDButton extends QButton {
  constructor() {
    super();
    this.fButtonName = "";
    this.fEnabledIcon = null;
    this.fDisabledIcon = null;
    this.fNumCols = 12;
    this.fTextColor = kOCNTextColor;
  }

  SetButtonInfo(buttonName, hoverCode) {
    this.fButtonName = buttonName;
    this.SetHoverCode(hoverCode);
  }

  SetImages(imageMgr, imageRef) {
    var yOffset = Math.floor(imageRef / 12);
    var xOffset = imageRef % 12;

    this.fSizing = kMediumIcon;

    var xSpacing = 96;
    var ySpacing = 96;

    var xSize = 32;
    var ySize = 32;

    var enabledImage = imageMgr.GetSubImage(
      enumImageIndex.appIcons,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing
    );
    var disabledImage = imageMgr.GetGraySubImage(
      enumImageIndex.appIcons,
      xOffset,
      yOffset,
      xSize,
      ySize,
      xSpacing,
      ySpacing
    );
    this.fEnabledImage = enabledImage;
    this.fDisabledImage = disabledImage;
  }

  DoRenderContent(drawBuffer) {
    this.DrawImage(drawBuffer);
    this.DrawLabel(drawBuffer);
  }

  DrawImage(drawBuffer) {
    var iconImage = this.fEnabledImage;
    var drawState = this.GetDrawState();

    if (drawState == enumElementDrawStates.Disabled) iconImage = this.fDisabledImage;

    var destWidth = this.fSizing.imageWidth;
    var destHeight = this.fSizing.imageHeight;

    var ctx = drawBuffer.getContext("2d");

    try {
      doDrawIcon(
        ctx,
        iconImage,
        0,
        0,
        iconImage.width,
        iconImage.height,
        Math.floor(this.fHorzOffset),
        Math.floor(this.fVertOffset),
        Math.floor(destWidth),
        Math.floor(destHeight),
        true
      );
    } catch (err) {
      return err;
    }
  }

  DrawLabel(drawBuffer) {
    var ctx = drawBuffer.getContext("2d");
    SetCtxFont(ctx, this.fFontString);

    var txtFillStyle = this.fTextColor;
    if (!this.IsEnabled()) txtFillStyle = "#A9A9A9";

    ctx.fillStyle = txtFillStyle;

    var theLabel = this.fButtonName;
    var txtHOffset = 4 + 28;
    var txtHeight = 8;
    var txtVOffset = (this.fHeight - txtHeight) / 2;

    ctx.fillText(
      theLabel,
      this.fHorzOffset + txtHOffset,
      this.fVertOffset + this.fHeight - txtVOffset
    );
  }
}
